var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "row col-12 col-md-8 d-flex justify-content-center justify-content-md-start pl-md-0 mt-3 mt-md-0 styled-scrollbar-custom pr-under-md-0 pl-under-md-0",
      attrs: { id: "verify-match-step-right-part" }
    },
    [
      _c(
        "div",
        {
          staticClass: "w-100",
          attrs: { id: "verify-match-step-right-part-inside" }
        },
        [
          _c(
            "div",
            { staticClass: "col-12 pl-0 pr-0 mb-1" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "small-text",
                  attrs: {
                    label: _vm.$t("annonce.vehicle.need.image"),
                    "label-for": "vehicleFiles-input",
                    "invalid-feedback": _vm.imagesVehicleState.invalidFeedback,
                    state: _vm.imagesVehicleState.state
                  }
                },
                [
                  _c("b-form-file", {
                    ref: "vehicleFiles-input",
                    attrs: {
                      id: "vehicleFiles-input",
                      "browse-text": _vm.$t("Select"),
                      placeholder: "",
                      multiple: "",
                      "drop-placeholder": _vm.$t("drop-placeholder"),
                      required: "",
                      accept: ".png, .jpeg, .jpg"
                    },
                    on: {
                      input: function($event) {
                        return _vm.setVehicleFiles($event)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("PreviewSeveralImages", {
            attrs: { fileId: "recto", files: _vm.vehicleFiles },
            on: { deleteFileInPreview: _vm.deleteFile }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-98cb1486", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98cb1486","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/match/VerifyMatchStep1.vue
// module id = d2xf
// module chunks = 0